// extracted by mini-css-extract-plugin
module.exports = {"srOnlyLabel":"_srOnlyLabel--3UssA"};